var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClinic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ClinicalPerformanceManagement - color",
    clipPath: "url(#clip0_1695_3765)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.0306 2.1936H2.08268C1.16221 2.1936 0.416016 2.9398 0.416016 3.86027V8.33321C0.416016 9.25369 1.16221 9.99988 2.08268 9.99988H3.08268V7.99988C3.08268 7.0794 3.82887 6.33321 4.74935 6.33321H5.24935C6.16982 6.33321 6.91602 7.0794 6.91602 7.99988V9.99988H7.91602C8.83649 9.99988 9.58268 9.25369 9.58268 8.33321V3.86027C9.58268 2.9398 8.83649 2.1936 7.91602 2.1936H7.16203V4.33325H3.0306V2.1936Z",
    fill: "#3992C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "gray",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99935 0.0224609C3.1249 0.0224609 2.41602 0.731344 2.41602 1.60579V3.60579C2.41602 4.48025 3.1249 5.18913 3.99935 5.18913H5.99935C6.8738 5.18913 7.58268 4.48025 7.58268 3.60579V1.60579C7.58268 0.731344 6.8738 0.0224609 5.99935 0.0224609H3.99935ZM4.99935 3.99988C4.76923 3.99988 4.58268 3.81333 4.58268 3.58321V2.99988H3.99935C3.76923 2.99988 3.58268 2.81333 3.58268 2.58321C3.58268 2.35309 3.76923 2.16654 3.99935 2.16654H4.58268V1.58321C4.58268 1.35309 4.76923 1.16654 4.99935 1.16654C5.22947 1.16654 5.41602 1.35309 5.41602 1.58321V2.16654H5.99935C6.22947 2.16654 6.41602 2.35309 6.41602 2.58321C6.41602 2.81333 6.22947 2.99988 5.99935 2.99988H5.41602V3.58321C5.41602 3.81333 5.22947 3.99988 4.99935 3.99988Z",
    fill: "#5DBEDF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1695_3765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinic);
export default __webpack_public_path__ + "static/media/clinic.fedc5e9ed23132614ca1375eaa945ce8.svg";
export { ForwardRef as ReactComponent };